module.exports = {
  'en': {
    'HRES33UC1': {
      '0': '[HRES33U] List of Personal Data Change',
      '10': '[HRES33U] List of Personal Data Change',
      '20': 'No.',
      '30': 'Employee Code',
      '40': 'Name',
      '50': 'Change Date',
      '60': 'Type of Change',
      '70': 'Status',
      '80': 'Code Appr.',
      '90': 'Appr. Date',
      '100': 'Remark',
      '110': 'Next Approve',
      '120': 'Order'
    },
    'HRES33UC10': {
      '0': 'List of  Change',
      '10': 'Employee Code',
      '11': 'Change Personal Data',
      '20': 'Change Date',
      '30': 'Seq.No.',
      '40': 'Fields',
      '50': 'Old Value',
      '60': 'New Value'
    },
    'HRES33UC11': {
      '0': 'Education Information',
      '10': 'Employee Code',
      '20': 'Change Date',
      '30': 'No.',
      '40': 'Change Data',
      '50': 'Old Data',
      '60': 'Edu. Level',
      '70': 'Degree',
      '80': 'Major',
      '90': 'Field of Study',
      '100': 'Institute',
      '110': 'Country',
      '120': 'G.P.A',
      '130': 'Year of Study From',
      '140': 'Year of Study To',
      '150': 'Type of Degree',
      '160': 'Update By',
      '170': 'Data Status'
    },
    'HRES33UC12': {
      '0': 'Children Information',
      '10': 'Employee Name',
      '20': 'Changed Date',
      '30': 'Data Change',
      '40': 'No.',
      '50': 'Children Name',
      '60': 'Birth Date',
      '70': 'Gender',
      '80': 'Previous Data',
      '90': 'Edu. Level',
      '100': 'Update By',
      '110': 'Data Status'
    },
    'HRES33UC13': {
      '0': 'Honour',
      '10': 'Employee Name',
      '20': 'Changed Date',
      '30': 'Type of Award',
      '40': 'Description',
      '50': 'Refer Doc.No',
      '60': 'Update By'
    },
    'HRES33UC14': {
      '0': 'Training Record',
      '10': 'Training Course',
      '20': 'Train Date from',
      '30': 'To Train Date',
      '40': 'Venue',
      '50': 'Organized By',
      '60': 'Data Status'
    },
    'HRES33UC15': {
      '0': 'Document Data',
      '10': 'Employee Name',
      '20': 'Changed Date',
      '30': 'Data Change',
      '40': 'Order',
      '50': 'Document Name',
      '60': 'File name',
      '70': 'Received Date',
      '80': 'Previous Data',
      '90': 'Update By',
      '100': 'Document type',
      '110': 'Document No.',
      '120': 'Expire Date',
      '130': 'Detail',
      '140': 'Data Status'
    },
    'HRES33UC16': {
      '0': 'Spouse Tax Deduction',
      '10': 'Employee Code',
      '20': 'Changed Date',
      '30': 'Tax Exception',
      '40': 'Item Code',
      '50': 'Description',
      '60': 'Amount',
      '70': 'Tax Allowance',
      '80': 'Item Code',
      '90': 'Description',
      '100': 'Amount',
      '110': 'Other Deduction',
      '120': 'Item Code',
      '130': 'Description',
      '140': 'Amount',
      '150': 'จำนวนบุตรที่กำลังศึกษา',
      '160': 'คน',
      '170': 'จำนวนบุตรที่ไม่ศึกษา',
      '180': 'คน',
      '190': 'Update By'
    },
    'HRES33UC2': {
      '0': 'Details of Approval',
      '10': 'For Emp.',
      '20': 'Change Date',
      '30': 'Type of Data Change',
      '40': 'Seq. No.',
      '50': 'Approved By',
      '60': 'Date',
      '70': 'Current Status',
      '80': 'Status',
      '90': 'Approved',
      '100': 'Rejected',
      '110': 'Remark',
      '120': 'No.of  selected',
      '130': 'Record'
    },
    'HRES33UC3': {
      '0': 'Employee Name Change',
      '10': 'Employee Name',
      '20': 'Changed Date',
      '30': 'Description',
      '40': 'Previous Data',
      '50': 'New Data',
      '60': 'Title',
      '70': 'Name(Thai)',
      '80': 'Last Name(Thai)',
      '90': 'Reason of change',
      '100': 'Update By',
      '110': 'Name(Eng)',
      '120': 'Last Name(Eng)'
    },
    'HRES33UC4': {
      '0': 'Personal Data',
      '10': 'Employee Code',
      '20': 'Changed Date',
      '30': 'Registration  Address',
      '40': 'Contact Address',
      '50': 'Address',
      '60': 'District',
      '70': 'Amphur',
      '80': 'Province',
      '90': 'Country',
      '100': 'Post/Zip',
      '110': 'Address',
      '120': 'District',
      '130': 'Amphur',
      '140': 'Province',
      '150': 'Country',
      '160': 'Post/Zip',
      '170': 'Tel. no',
      '180': 'Update By'
    },
    'HRES33UC5': {
      '0': 'Personal Data(2)',
      '10': 'Employee Code',
      '20': 'Changed Date',
      '30': 'ID Card',
      '40': 'ID. Card NO.',
      '50': 'Place of Issue',
      '60': 'Province',
      '70': 'Expire Date',
      '75': 'Passport / Work Permit No.',
      '80': 'Passport Number',
      '90': 'Expire Date',
      '100': 'Work Permit Number',
      '110': 'Work Permit Issue Date',
      '120': 'Work Permit Expire  Date',
      '130': 'Driving License',
      '140': 'ID License',
      '150': 'Expire Date',
      '160': 'Ohter Status',
      '170': 'Marital Status',
      '180': 'Military Service',
      '190': 'Update By'
    },
    'HRES33UC6': {
      '0': 'Parents Information',
      '10': 'Employee Code',
      '20': 'Changed Date',
      '30': 'Father"s Information',
      '40': 'Name',
      '50': 'Nationality',
      '60': 'Relegion',
      '70': 'Occupation',
      '80': 'Father Citizen i.d',
      '90': 'Mother"s Information',
      '100': 'Name',
      '110': 'Nationality',
      '120': 'Relegion',
      '130': 'Occupation',
      '140': 'Mother Citizen i.d',
      '150': 'Emergency Contact Person',
      '160': 'Name',
      '170': 'Address',
      '180': 'Post/Zip',
      '190': 'Tel. No',
      '200': 'Fax.no',
      '210': 'Email-Address',
      '220': 'Relationship',
      '230': 'Update By'
    },
    'HRES33UC7': {
      '0': 'Employee "s Spouse Data',
      '10': 'Employee Code',
      '20': 'Changed Date',
      '30': 'Spouse Information',
      '40': 'Registration Information',
      '50': 'Title',
      '51': 'Name',
      '52': 'Last Name',
      '60': 'Citizen ID.',
      '70': 'Birth Date',
      '80': 'Occupation',
      '90': 'Work Place',
      '100': 'Date',
      '110': 'Place of Registration',
      '120': 'City',
      '130': 'Country',
      '140': 'Oths. Information',
      '150': 'Update By'
    },
    'HRES33UC8': {
      '0': 'Bank Account Information',
      '10': 'Employee Code',
      '20': 'Changed Date',
      '30': 'Bank Code',
      '40': 'Account No.',
      '50': '% Deposit',
      '60': 'Bank Code',
      '70': 'Account No.',
      '80': '% Deposit',
      '90': 'Update By'
    },
    'HRES33UC9': {
      '0': 'Expense',
      '10': 'Employee Code',
      '20': 'Changed Date',
      '30': 'Tax Exception',
      '40': 'Item Code',
      '50': 'Description',
      '60': 'Amount',
      '70': 'Tax Allowance',
      '80': 'Item Code',
      '90': 'Description',
      '100': 'Amount',
      '110': 'Other Deduction',
      '120': 'Item Code',
      '130': 'Description',
      '140': 'Amount',
      '150': 'จำนวนบุตรที่กำลังศึกษา',
      '160': 'คน',
      '170': 'จำนวนบุตรที่ไม่ศึกษา',
      '180': 'คน',
      '190': 'Update By'
    }
  },
  'th': {
    'HRES33UC1': {
      '0': '[HRES33U] การเปลี่ยนแปลงข้อมูลพนักงาน',
      '10': '[HRES33U] การเปลี่ยนแปลงข้อมูลพนักงาน',
      '20': 'ลำดับที่',
      '30': 'รหัสพนักงาน',
      '40': 'ชื่อ',
      '50': 'วันที่ขอเปลี่ยน',
      '60': 'ประเภทข้อมูล',
      '70': 'สถานะ',
      '80': 'ผู้อนุมัติ',
      '90': 'วันที่อนุมัติ',
      '100': 'หมายเหตุการอนุมัติ',
      '110': 'ผู้อนุมัติลำดับถัดไป',
      '120': 'ลำดับที่ขอ'
    },
    'HRES33UC10': {
      '0': 'รายการที่มีการแก้ไขข้อมูล',
      '10': 'รหัสพนักงาน',
      '11': 'การขอเปลี่ยนแปลงข้อมูลส่วนตัว',
      '20': 'วันที่ขอเปลี่ยน',
      '30': 'ลำดับที่',
      '40': 'ข้อมูล',
      '50': 'ข้อมูลเดิม',
      '60': 'ข้อมูลใหม่'
    },
    'HRES33UC11': {
      '0': 'ข้อมูลการศึกษา',
      '10': 'รหัสพนักงาน',
      '20': 'วันที่ขอเปลี่ยน',
      '30': 'ลำดับที่',
      '40': 'ข้อมูลที่แก้ไข',
      '50': 'ข้อมูลเดิม',
      '60': 'ระดับการศึกษา',
      '70': 'วุฒิการศึกษา',
      '80': 'คณะ/สาขาวิชา',
      '90': 'สาขาวิชาเอก',
      '100': 'สถาบัน',
      '110': 'ประเทศ',
      '120': 'เกรดเฉลี่ย',
      '130': 'ปีที่เริ่มการศึกษา',
      '140': 'ปีที่จบการศึกษา',
      '150': 'วุฒิการศึกษา',
      '160': 'ผู้บันทึก',
      '170': 'สถานะข้อมูล'
    },
    'HRES33UC12': {
      '0': 'ข้อมูลบุตร',
      '10': 'ชื่อพนักงาน',
      '20': 'วันที่ขอเปลี่ยน',
      '30': 'ข้อมูลที่แก้ไข',
      '40': 'ที่',
      '50': 'ชื่อบุตร',
      '60': 'วันเกิด',
      '70': 'เพศ',
      '80': 'ข้อมูลก่อนการแก้ไข',
      '90': 'ระดับการศึกษา',
      '100': 'ผู้บันทึก',
      '110': 'สถานะข้อมูล'
    },
    'HRES33UC13': {
      '0': 'ข้อมูลคุณความดี',
      '10': 'ชื่อพนักงาน',
      '20': 'วันที่ขอเปลี่ยน',
      '30': 'ประเภทของรางวัล',
      '40': 'รายละเอียด',
      '50': 'เลขที่เอกสารอ้างอิง',
      '60': 'ผู้บันทึก'
    },
    'HRES33UC14': {
      '0': 'ข้อมูลการฝึกอบรม',
      '10': 'หลักสูตรอบรม',
      '20': 'วันที่ฝึกอบรมตั้งแต่',
      '30': 'ถึง วันที่ฝึกอบรม',
      '40': 'สถานที่ฝึกอบรม',
      '50': 'จัดโดย',
      '60': 'สถานะข้อมูล'
    },
    'HRES33UC15': {
      '0': 'เอกสารส่วนตัว',
      '10': 'ชื่อพนักงาน',
      '20': 'วันที่ขอเปลี่ยน',
      '30': 'ข้อมูลที่แก้ไข',
      '40': 'ลำดับที่',
      '50': 'ชื่อเอกสาร',
      '60': 'File name',
      '70': 'วันที่รับ',
      '80': 'ข้อมูลก่อนการแก้ไข',
      '90': 'ผู้บันทึก',
      '100': 'ประเภทเอกสาร',
      '110': 'เลขที่เอกสาร',
      '120': 'วันที่หมดอายุ',
      '130': 'รายละเอียด',
      '140': 'สถานะข้อมูล'
    },
    'HRES33UC16': {
      '0': 'ลดหย่อนคู่สมรส',
      '10': 'รหัสพนักงาน',
      '20': 'วันที่ขอเปลี่ยน',
      '30': 'เงินได้ยกเว้นภาษี',
      '40': 'รหัสรายการ',
      '50': 'รายละเอียด',
      '60': 'จำนวนเงิน',
      '70': 'ค่าลดหย่อนภาษี',
      '80': 'รหัสรายการ',
      '90': 'รายละเอียด',
      '100': 'จำนวนเงิน',
      '110': 'ส่วนหักอื่น ๆ ',
      '120': 'รหัสรายการ',
      '130': 'รายละเอียด',
      '140': 'จำนวนเงิน',
      '150': 'จำนวนบุตรที่กำลังศึกษา',
      '160': 'คน',
      '170': 'จำนวนบุตรที่ไม่ศึกษา',
      '180': 'คน',
      '190': 'ผู้บันทึก'
    },
    'HRES33UC2': {
      '0': 'รายละเอียดการอนุมัติ',
      '10': 'สำหรับพนักงาน',
      '20': 'วันที่แจ้งเปลี่ยนแปลง',
      '30': 'ประเภทการเปลี่ยนแปลง',
      '40': 'ลำดับที่',
      '50': 'รหัสผู้อนุมัติ',
      '60': 'วันที่',
      '70': 'สถานะปัจจุบัน',
      '80': 'สถานะ',
      '90': 'อนุมัติ',
      '100': 'ไม่อนุมัติ',
      '110': 'หมายเหตุ',
      '120': 'รายการที่เลือกทั้งหมด',
      '130': 'รายการ'
    },
    'HRES33UC3': {
      '0': 'การเปลี่ยนแปลงชื่อพนักงาน',
      '10': 'รหัสพนักงาน',
      '20': 'วันที่ขอเปลี่ยน',
      '30': 'รายละเอียด',
      '40': 'ข้อมูลเดิม',
      '50': 'ข้อมูลใหม่',
      '60': 'คำนำหน้า',
      '70': 'ชื่อ(ไทย)',
      '80': 'นามสกุล(ไทย)',
      '90': 'เหตุผล',
      '100': 'ผู้บันทึก',
      '110': 'ชื่อ(อังกฤษ)',
      '120': 'นามสกุล(อังกฤษ)'
    },
    'HRES33UC4': {
      '0': 'ข้อมูลส่วนตัว',
      '10': 'รหัสพนักงาน',
      '20': 'วันที่ขอเปลี่ยน',
      '30': 'ที่อยู่ตามทะเบียนบ้าน',
      '40': 'ที่อยู่ที่ติดต่อได้',
      '50': 'ที่อยู่',
      '60': 'ตำบล',
      '70': 'อำเภอ',
      '80': 'จังหวัด',
      '90': 'ประเทศ',
      '100': 'รหัสไปรษณีย์',
      '110': 'ที่อยู่',
      '120': 'ตำบล',
      '130': 'อำเภอ',
      '140': 'จังหวัด',
      '150': 'ประเทศ',
      '160': 'รหัสไปรษณีย์',
      '170': 'โทรศัพท์',
      '180': 'ผู้บันทึก'
    },
    'HRES33UC5': {
      '0': 'ข้อมูลส่วนตัว(2)',
      '10': 'รหัสพนักงาน',
      '20': 'วันที่ขอเปลี่ยน',
      '30': 'บัตรประชาชน',
      '40': 'เลขที่บัตร',
      '50': 'ออกบัตรที่',
      '60': 'จังหวัด',
      '70': 'วันหมดอายุ',
      '75': 'ข้อมูลหนังสือเดินทาง/ใบอนุญาติทำงาน',
      '80': 'เลขที่พาสปอร์ต',
      '90': 'วันหมดอายุ',
      '100': 'เลขที่ใบอนุญาติทำงาน',
      '110': 'วันที่ออกใบอนุญาต',
      '120': 'วันที่หมดอายุ',
      '130': 'ใบอนุญาตขับขี่',
      '140': 'เลขที่ใบอนุญาต',
      '150': 'วันหมดอายุ',
      '160': 'สถานะอื่นๆ',
      '170': 'สถานภาพสมรส',
      '180': 'สถานะทหาร',
      '190': 'ผู้บันทึก'
    },
    'HRES33UC6': {
      '0': 'ข้อมูลบิดา-มารดา',
      '10': 'รหัสพนักงาน',
      '20': 'วันที่ขอเปลี่ยน',
      '30': 'ข้อมูลของบิดา',
      '40': 'ชื่อ',
      '50': 'สัญชาติ',
      '60': 'ศาสนา',
      '70': 'อาชีพ',
      '80': 'เลขที่บัตรประชาชนบิดา',
      '90': 'ข้อมูลของมารดา',
      '100': 'ชื่อ',
      '110': 'สัญชาติ',
      '120': 'ศาสนา',
      '130': 'อาชีพ',
      '140': 'เลขที่บัตรประชาชนมารดา',
      '150': 'บุคคลที่สามารถติดต่อได้กรณีฉุกเฉิน',
      '160': 'ชื่อ',
      '170': 'ที่อยู่',
      '180': 'รหัสไปรษณีย์',
      '190': 'โทรศัพท์',
      '200': 'แฟกซ์',
      '210': 'อีเมล์',
      '220': 'ความสัมพันธ์',
      '230': 'ผู้บันทึก'
    },
    'HRES33UC7': {
      '0': 'ข้อมูลคู่สมรส',
      '10': 'รหัสพนักงาน',
      '20': 'วันที่ขอเปลี่ยน',
      '30': 'ข้อมูลของคู่สมรส',
      '40': 'ข้อมูลการจดทะเบียน',
      '50': 'คำนำหน้า',
      '51': 'ชื่อ',
      '52': 'นามสกุล',
      '60': 'เลขบัตรประชาชน',
      '70': 'วันเกิด',
      '80': 'อาชีพ',
      '90': 'สถานที่ทำงาน',
      '100': 'วันที่',
      '110': 'สถานที่จดทะเบียน',
      '120': 'จังหวัด',
      '130': 'ประเทศ',
      '140': 'รายละเอียดอื่นๆ',
      '150': 'ผู้บันทึก'
    },
    'HRES33UC8': {
      '0': 'ข้อมูลธนาคาร',
      '10': 'รหัสพนักงาน',
      '20': 'วันที่ขอเปลี่ยน',
      '30': 'รหัสธนาคาร',
      '40': 'เลขที่บัญชี',
      '50': '% เข้าบัญชี',
      '60': 'รหัสธนาคาร',
      '70': 'เลขที่บัญชี',
      '80': '% เข้าบัญชี',
      '90': 'ผู้บันทึก'
    },
    'HRES33UC9': {
      '0': 'ลดหย่อนภาษี',
      '10': 'รหัสพนักงาน',
      '20': 'วันที่ขอเปลี่ยน',
      '30': 'เงินได้ยกเว้นภาษี',
      '40': 'รหัสรายการ',
      '50': 'รายละเอียด',
      '60': 'จำนวนเงิน',
      '70': 'ค่าลดหย่อนภาษี',
      '80': 'รหัสรายการ',
      '90': 'รายละเอียด',
      '100': 'จำนวนเงิน',
      '110': 'ส่วนหักอื่น ๆ ',
      '120': 'รหัสรายการ',
      '130': 'รายละเอียด',
      '140': 'จำนวนเงิน',
      '150': 'จำนวนบุตรที่กำลังศึกษา',
      '160': 'คน',
      '170': 'จำนวนบุตรที่ไม่ศึกษา',
      '180': 'คน',
      '190': 'ผู้บันทึก'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres33u.js